export default {
  path: '/order-list',
  meta: {
    title: '我的订单',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/order-list`),
}



// WEBPACK FOOTER //
// ./src/views/OrderList/router.js